import { render, staticRenderFns } from "./receivingfrm.vue?vue&type=template&id=a93c7d40"
import script from "./receivingfrm.vue?vue&type=script&lang=js"
export * from "./receivingfrm.vue?vue&type=script&lang=js"
import style0 from "./receivingfrm.vue?vue&type=style&index=0&id=a93c7d40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports